// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
    //suggestionMode: 'test',
    //suggestionPosition: 'right',
    //suggestionWidth: 'auto'
    //suggestionMobileStyle: 'style2'
  }
};

(function () {
BoostPFS.inject(this);

  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function(suggestionElement, searchElement, searchBoxId) {};
  SearchInput.prototype._onClickSearchBox = function(event) {
    // Close more
    if (Utils.isMobile()) $( "body .js-search-draw .js-close-mfp").trigger("click");
    
    jQ('.boost-pfs-search-btn-close-suggestion').on('click', function() {
      jQ('.mfp-auto-cursor').removeClass('boost-hidden');
    })
  };
  
    // Bind Event for input search style 3
  var bindEvents = InstantSearchStyle3.prototype.bindEvents;
  InstantSearchStyle3.prototype.bindEvents = function() {
    bindEvents.call(this);

    var self = this;

    jQ('.header-trigger__link--search').off('click').click(function(e) {
      e.preventDefault();
      jQ('.search__form-input').focus();
      self.openSuggestionStyle3();
      
      setTimeout(function() {
      	jQ('body .js-search-draw .js-close-mfp').trigger("click")
      }, 300)
    });
  }
  
})();